import {Campaign, UserErrorCodes} from '../../../../types/src';

import {brandConfig} from '../constants/brandConfig';
import {STRINGS} from '../constants';

export const getCampaignErrorMessageByCode = (errorCode: string) => {
  if (!errorCode) {
    return '';
  }

  return STRINGS.errors.campaign[errorCode] || STRINGS.errors.campaign.error_default;
};

export const formatCampaignErrorMessage = (errorCode: string, campaign?: Partial<Campaign>) => {
  const message = getCampaignErrorMessageByCode(errorCode);

  if (!message) {
    return '';
  }

  return message
    .replace('{campaign.name}', campaign?.name || '')
    .replace('{user.email}', campaign?.selectedUser?.email || '')
    .replace('{brandConfig.contact}', brandConfig.contact);
};

export const getUserErrorMessageByCode = (errorCode: string) => {
  if (!errorCode) {
    return '';
  }

  return STRINGS.errors.user[errorCode] || STRINGS.errors.user[UserErrorCodes.Default];
};
